import { render, staticRenderFns } from "./resultGenerateFromTabulation.vue?vue&type=template&id=527a3c30&scoped=true&"
import script from "./resultGenerateFromTabulation.vue?vue&type=script&lang=js&"
export * from "./resultGenerateFromTabulation.vue?vue&type=script&lang=js&"
import style0 from "./resultGenerateFromTabulation.vue?vue&type=style&index=0&id=527a3c30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a3c30",
  null
  
)

export default component.exports